import styled from 'styled-components';

export const PageTitle = styled.div`
  font-size: var(--font-xl);
`;
export const SectionHeading = styled.div`
  font-size: var(--font-l);
`;
